import Collection_Base from 'collection/base';
import Model_Notification from 'model/notification';

export default Collection_Base.extend({
    model: Model_Notification,
});